import * as React from "react";
import * as cls from "./modalZetLessons.module.scss";
import Warn from "../../resources/icons/Warn";
import { Icon } from "../../../personal-studio-components/studio";
import { useNavigate } from "react-router-dom";
import QuestionRed from "../../resources/icons/QuestionRed";
const product_states = {
  Начать: "normal",
  Продолжить: "continue_session",
  Пройдено: "completed",
  "Требуется оплата": "not_paid",
  Перезапись: "self_record_rewrite",
  "Дата не наступила": "self_record_date_assigned",
  Запланировать: "self_record_needed",
  Недоступно: "unavailable",
};

function TableItem({ el, handleClose, withTopic }) {
  const navigate = useNavigate();
  const textRef = React.useRef(null);
  const [isTruncated, setIsTruncated] = React.useState(false);
  React.useLayoutEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        const hasEllipsis =
          textRef.current.scrollWidth > textRef.current.clientWidth;
        setIsTruncated(hasEllipsis);
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [el.state]);
  if (el.is_filler)
    return (
      <div
        className={`${cls.tableRow} ${cls.tableRowMobile} ${cls.filler}`}
      ></div>
    );
  return (
    <>
      <div className={`${cls.tableRow} ${cls.tableRowMobile}`}>
        <div style={{ flex: 3 }}>
          <div className={`${cls.tableRowContent}`}>
            <div className={cls.mustEvaluate}>
              <div
                className={cls.mandatoryLessons}
                title="Обязательные занятия"
              >
                {el.must_evaluate && <Warn />}
              </div>

              <div className={cls.zetIsCompleted}>
                {el.is_completed && <Icon name="check" title="Завершено" />}
              </div>

              <div
                className={cls.zetIsPayd}
                title="Оплатить"
                onClick={() => navigate("/payment")}
              >
                {el.is_zet_paid === 0 && (
                  <div className={cls.section_icon}>
                    <Icon name="ruble" className="iconRuble" />
                  </div>
                )}
              </div>
            </div>

            <div className={cls.tableCell} data-label="Вид занятия">
              {el.lesson_subkind_fullname}
            </div>
            {/* {!withTopic && ( */}
            <div className={cls.tableCellTpName} data-label="Тема занятия">
              {el.tp_name}
            </div>
            {/* )} */}
          </div>

          <div className={cls.lessonMessage}>
            <div style={{ flex: 3 }}>{el.message}</div>
          </div>
        </div>
        <div
          className={cls.tableCellBtn}
          title={el.state}
          data-label="Обучение"
        >
          {el.link !== "" ? (
            <a
              target="_blank"
              href={el.link}
              className={`${cls[product_states[el.state]] || cls.normal} ${cls.btn}`}
            >
              <span className={cls.textTruncate}>{el.state}</span>
            </a>
          ) : (
            <div
              className={`${cls.text} ${cls[product_states[el.state]] || cls.normal}`}
            >
              <span className={cls.textTruncate} ref={textRef}>
                {el.state}
              </span>
              {isTruncated && (
                <span className={cls.textIcon}>
                  <QuestionRed />
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TableItem;
